<template>
  <div class="bg-white">
    <div class="contact-banner">
      <el-image
          class="inherit-w"
          :src="bannerImg"
          style="max-height: 500px; min-height: fit-content"
          fit="contain"
      />
    </div>
    <div class="page-padding"/>
    <div class="container">
      <div class="container-content bg-white-1 text-black-2">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="7" :md="6">
            <p class="py-2 fs-large fw-600 text-primary shadow-text">
              联系我们
            </p>
            <div v-for="(value, key) in ORG_INFORMATION" :key="key">
              <div v-if="labels[key]" class="my-4">
                <div style="display: flex; align-items: flex-start">
                  <el-icon class="v-a mr-2 fs-xl" style="display: inline-block"
                  >
                    <component :is="iconMap[key]"
                    />
                  </el-icon>
                  <span class="fs-xl" style="display: inline-block; line-height: 1rem;">{{ labels[key] }}:</span>

                  <span class="ml-2 fs-xl" v-if="key !== 'phone'" style="display: inline-block; line-height: 1rem;">{{ value }}</span>
                  <div v-else class="ml-2">
                    <ul>
                      <li v-for="item in value" class="fs-xl" style="margin-bottom: 5px">{{ item }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-2 mb-2">
              <p
                  class="fs-lg"
                  style="color: #7b7575; cursor: default"
                  v-html="ORG_REMARKS"
              />
            </div>
          </el-col>
          <el-col :xs="24" :sm="17" :md="18">
            <div class="map-wrapper" style="border: 1px solid #dadce0">
              <AMapItem/>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="page-padding"/>
  </div>
</template>

<script setup>
import {reactive, ref, computed, onMounted} from 'vue'

import {Message, LocationInformation, Phone} from '@element-plus/icons-vue'
import {setPV} from '@/api/config.js'

import AMapItem from '@/components/a-map/index.vue'
import bannerImg from '@/assets/images/contact/banner.jpg'

import {ORG_INFORMATION, ORG_REMARKS} from '@/config/constant.js'

const iconMap = {
  email: Message,
  address: LocationInformation,
  phone: Phone
}

const labels = {
  email: '邮箱',
  phone: '电话',
  address: '地址'
}

onMounted(async () => {
  await setPV()
})
</script>

<style lang="scss" scoped></style>
